// layouts/auth/SignOut.jsx
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "layouts/auth/AuthContext";
import api from "services/api";

// UI (usa lo que ya tienes en el proyecto)
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export default function SignOut() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;         // evita doble ejecución en StrictMode
    ranRef.current = true;

    (async () => {
      try {
        // 1) (Opcional) notificar al backend
        // Puedes configurar el endpoint desde localStorage si tu API usa otro path.
        const logoutPath =
          localStorage.getItem("api_logout_path") || "/auth/logout";
        try {
          await api.post(logoutPath);
        } catch {
          // Silenciamos si la API no expone /auth/logout o no es necesario
        }

        // 2) Limpiar cualquier key de depuración/opcional
        try {
          localStorage.removeItem("debug_user_id");
          localStorage.removeItem("debug_perms");
        } catch {}

        // 3) Logout del cliente (borra token, limpia headers, user=null)
        logout();
      } finally {
        // 4) Redirigir
        const qp = new URLSearchParams(location.search);
        const redirectTo =
          qp.get("redirect") || "/authentication/sign-in";
        navigate(redirectTo, { replace: true });
      }
    })();
  }, [logout, navigate, location.search]);

  return (
    <SoftBox
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "70vh" }}
    >
      <Card style={{ padding: 24 }}>
        <SoftBox display="flex" alignItems="center" gap={2}>
          <CircularProgress size={22} />
          <SoftTypography variant="button">
            Cerrando sesión…
          </SoftTypography>
        </SoftBox>
      </Card>
    </SoftBox>
  );
}
